import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

class RatingUpdateState extends APIRequestState {
  putRequest(urlId, ...params) {
    return this.ctx.sdk.post(`/orders/${urlId}/rate`, ...params);
  }
}

class RatingState {
  @lazyInitialize @nonenumerable ratingUpdate = new RatingUpdateState(this.ctx);

  @nonenumerable listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default RatingState;



// WEBPACK FOOTER //
// ./spa/state/rating.jsx